import { Injectable, inject } from '@angular/core'
import { LoggerService } from './logger.service'
import { StandaloneTokenService } from './standalone-token.service'

@Injectable({
  providedIn: 'root',
})
export class TokenInitializationService {
  private standaloneTokenService = inject(StandaloneTokenService)
  private logger = inject(LoggerService)

  /**
   * Initialize token from URL or storage
   */
  async initializeToken(): Promise<void> {
    // First, try to extract token from URL
    const urlToken: string | null = this.standaloneTokenService.extractTokenFromUrl()

    if (urlToken) {
      this.logger.log('Shared token found in URL, validating...')
      this.standaloneTokenService.storeToken(urlToken)
    }
  }

  hasToken(): boolean {
    return this.standaloneTokenService.getCurrentToken() != null
  }
}
